import {ButtonHTMLAttributes, DetailedHTMLProps, FC} from "react";

type Props = {
    type?: "button" | "submit" | "reset";
    className?: string;
} & DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>

const Button: FC<Props> = (props) => {
    return (
        <button {...props} className={`text-white flex items-center font-semibold text-sm uppercase tracking-wider px-4 py-2 rounded-md shadow-lg transition-all hover:pr-6 ${props.className ? props.className : 'bg-secondary hover:shadow-secondary/20'}`} type={props.type}>
            {props.children}
        </button>
    );
};

export default Button;